import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/components/site/assets";

export function PortalLayout({ roleLabel, children }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="portal-layout">
      <header className="border-b border-white/10 bg-black sticky top-0 z-20">
        <div className="max-w-6xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="JJ Speed Factory" className="h-10 w-auto object-contain" />
            <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-white/40 border-l border-white/20 pl-3">
              {roleLabel}
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden sm:block text-white/40 text-xs" data-testid="portal-user">{user?.email}</span>
            <button
              data-testid="portal-logout"
              onClick={logout}
              className="inline-flex items-center gap-2 border border-white/20 px-4 py-2 text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-colors"
            >
              <LogOut size={14} /> Log Out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 md:px-12 py-10 lg:py-14">{children}</main>
    </div>
  );
}

export const SectionTitle = ({ children }) => (
  <h2 className="font-display font-bold uppercase tracking-tight text-xl mb-4">{children}</h2>
);

export const Panel = ({ children, className = "", ...props }) => (
  <div className={`bg-[#121212] border border-white/10 p-6 ${className}`} {...props}>{children}</div>
);

export const EmptyState = ({ children, testid }) => (
  <div className="text-white/40 text-sm border border-white/10 bg-[#121212] p-6" data-testid={testid}>{children}</div>
);
